// Petit "bloup" de bulle synthétisé (Web Audio API) — aucun fichier, marche hors-ligne.
// Réglage on/off persistant (localStorage). Respecte aussi le silence système (le
// navigateur ne joue rien si le contexte audio ne peut pas démarrer).

export function soundEnabled() {
    return localStorage.getItem("sdaSound") !== "off";
}
export function setSoundEnabled(on) {
    localStorage.setItem("sdaSound", on ? "on" : "off");
}

let ctx = null;

// Amorçage : les navigateurs interdisent l'audio tant qu'il n'y a pas eu de geste
// utilisateur. On crée/réveille le contexte au 1er clic/toucher/touche pour que les
// « bloups » suivants (popups en cours de session) partent bien.
function armAudio() {
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        ctx = ctx || new AC();
        if (ctx.state === "suspended") ctx.resume();
    } catch { /* ignore */ }
}
if (typeof window !== "undefined") {
    const arm = () => { armAudio(); };
    window.addEventListener("pointerdown", arm, { once: true, capture: true });
    window.addEventListener("keydown", arm, { once: true, capture: true });
    window.addEventListener("touchstart", arm, { once: true, capture: true });
}

export function playBubble() {
    if (!soundEnabled()) return;
    try {
        const AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return;
        ctx = ctx || new AC();
        if (ctx.state === "suspended") ctx.resume();
        const t = ctx.currentTime;
        const o = ctx.createOscillator();
        const g = ctx.createGain();
        o.type = "sine";
        // Montée rapide de fréquence + extinction douce = ce petit "bloup" aquatique.
        o.frequency.setValueAtTime(280, t);
        o.frequency.exponentialRampToValueAtTime(760, t + 0.12);
        g.gain.setValueAtTime(0.0001, t);
        g.gain.exponentialRampToValueAtTime(0.25, t + 0.02);
        g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
        o.connect(g);
        g.connect(ctx.destination);
        o.start(t);
        o.stop(t + 0.24);
    } catch {
        /* audio indisponible : on ignore silencieusement */
    }
}
